export const formatPropertyType = (val?: string | null) => {
    if (!val) return '';
    const s = String(val).replace(/_/g, ' ').toLowerCase();
    return s
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};

export const formatDateTime = (dateString?: string | null) => {
    if (!dateString) return 'N/A';

    try {
        const date = new Date(dateString);

        // Check if date is valid
        if (isNaN(date.getTime())) return 'Invalid Date';

        // Format exactly like the table logic
        const formattedDate = date.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        // Format date without comma - split and rejoin
        const [day, month, year, time, ampm] = formattedDate.split(' ');
        return `${day} ${month} ${year} ${time} ${ampm}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid Date';
    }
};

export const formatPrice = (price?: string | number | null) => {
    if (price === null || price === undefined || price === '') return 'N/A';

    try {
        // Convert to number if it's a string
        const numPrice = typeof price === 'string' ? parseFloat(price) : price;

        // Check if it's a valid number
        if (isNaN(numPrice)) return 'N/A';

        // Format with commas only (no currency symbol)
        const formattedNumber = numPrice.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });

        return formattedNumber;
    } catch (error) {
        console.error('Error formatting price:', error);
        return 'N/A';
    }
};

// Function to truncate ID (show only part before first dash + "...")
export const getTruncatedId = (id?: string | null) => {
    if (!id) return 'N/A';
    const firstDashIndex = id.indexOf('-');
    return firstDashIndex > 0 ? id.substring(0, firstDashIndex) + '...' : id;
};

// Function to format strings by capitalizing first letter of each word and removing underscores
export const formatStringWithUnderscores = (str?: string | null) => {
    if (!str) return '';
    const s = String(str).replace(/_/g, ' ');
    return s
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

// Function to capitalize first letter of each word
export const capitalizeWords = (str: string) => {
    if (!str) return '';
    return str.split(' ').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
};

// Function to format full name from first_name and last_name
export const formatFullName = (firstName: string, lastName: string) => {
    const first = capitalizeWords(firstName || '');
    const last = capitalizeWords(lastName || '');
    return `${first} ${last}`.trim() || 'N/A';
};

// Helper function to format file size
export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};